import React from 'react';
import BeaconComparableSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconComparableSplineChart';
import {
  useEntityPhrasing,
  useTaxonomySubtitleText
} from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';
import { useCreateRemoveRetailPriceRangeFilters } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy/useBaseMetricRequestBuilder';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import {
  useAppSelector,
  useComparisonTimePeriodShortDisplayName,
  useMainTimePeriodShortDisplayName
} from 'src/utils/Hooks';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import _upperFirst from 'lodash/upperFirst';
import { BeaconSubtitleContainer } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconSubtitleContainer';
import { shouldShowBeaconProTopics } from 'src/utils/app';
import SubtitleFilters from 'src/components/Charts/SubtitleFilters';

export default function OrganicTrafficSplineChart() {
  // TODO: Use agg-traffic index when available for topics
  const mainEntityType = useAppSelector((state) => state.entityService.mainEntity.type);
  const { isProductEntity } = useProductEntity();
  const removeRetailPriceRangeFilters = useCreateRemoveRetailPriceRangeFilters();
  const mainPeriodDisplayName = useMainTimePeriodShortDisplayName();
  const comparisonDisplayName = useComparisonTimePeriodShortDisplayName();
  const isCategoryEntity = mainEntityType === 'category';
  const isSubcategoryEntity = mainEntityType === 'subcategory';
  const titleOnly = !(isProductEntity || isCategoryEntity || isSubcategoryEntity);
  const entityPhrase = useEntityPhrasing({ titleOnly });
  const taxonomyText = useTaxonomySubtitleText();

  const getSubtitle = ({ organicTraffic, formattedPercent, direction }) => {
    const changeDirection = direction < 0 ? 'lower' : 'higher';
    return (
      <BeaconSubtitleContainer>
        <Text variant="body1">
          {`${_upperFirst(entityPhrase)} earned ${organicTraffic} organic traffic `}
          {taxonomyText}
          {` during the ${mainPeriodDisplayName} time period, which is ${formattedPercent} ${changeDirection} compared to the ${comparisonDisplayName}.`}
          <SubtitleFilters />
        </Text>
      </BeaconSubtitleContainer>
    );
  };

  return (
    <BeaconComparableSplineChart
      beaconChartWithLegendOverride={
        shouldShowBeaconProTopics()
          ? (props, metric) => {
              const { formattedPrimaryTotal, formattedPercentChange, primaryTotal, secondaryTotal } = metric;
              const subtitle = getSubtitle({
                organicTraffic: formattedPrimaryTotal,
                formattedPercent: formattedPercentChange,
                direction: primaryTotal - secondaryTotal
              });

              return { ...props, includeSummaryInfo: false, subtitle };
            }
          : undefined
      }
      indexName={mainEntityType === 'searchtermlist' ? 'traffic' : 'aggregated-traffic'}
      fieldName="organicClicks"
      requestBuilder={removeRetailPriceRangeFilters()}
    />
  );
}
